import Formation, { TypeFormation } from "../../models/Formation";
import BilanDeCompetence from "../bilans-bilan-de-competence.webp";

const bilansData: Formation[] = [
  {
    image: BilanDeCompetence,
    title: "Bilan de compétences",
    description:
      "Les bilans de compétences sont des outils essentiels qui incitent les salariés à réfléchir et à progresser dans leur parcours professionnel, composé de multiples étapes distinctes.",
    id: "bilan-de-competence",
    type: TypeFormation.BilanDeCompetence,
    content: (
      <div>
        <p>
          Le bilan de compétences est un dispositif d’accompagnement individuel
          destiné à faciliter l’évolution professionnelle. Il permet d’analyser
          les compétences professionnelles et personnelles, les aptitudes et les
          motivations, afin de construire un projet professionnel cohérent et,
          si nécessaire, un projet de formation. Son objectif est de dresser un
          portrait précis de votre profil professionnel et d’identifier les
          actions à mettre en œuvre pour envisager une trajectoire d’évolution
          adaptée (articles L.6313-4 et R.6313-4).
        </p>
        <h2>Public visé</h2>
        <p>Tout public</p>
        <p>
          Salariés ou agents souhaitant s'engager dans une démarche volontaire
          et personnalisée, prêt à être acteur ou actrice principale de son
          bilan ;
        </p>
        <p>
          Demandeur d’emploi souhaitant s'engager dans une démarche volontaire
          et personnalisée, prêt à être acteur ou actrice principale de son
          bilan.
        </p>
        <h2>Dispositions pratiques</h2>
        <p>Effectif maximum : 1 participant</p>
        <p>Salariés du secteur privé et/ou public</p>
        <ul>
          <li>
            <p>
              Sur le temps de travail : l’accord de votre employeur est
              nécessaire ;
            </p>
          </li>
          <li>
            <p>
              En dehors du temps de travail : vous n’êtes pas tenu d’en informer
              votre employeur ;
            </p>
          </li>
          <li>
            <p>
              Partiellement sur le temps de travail : une négociation avec votre
              employeur est nécessaire pour vous libérer de vos heures de
              travail.
            </p>
          </li>
        </ul>
        <h2>Objectifs pédagogiques</h2>
        <ul>
          <li>
            <p>
              Identifier ses aspirations, ses valeurs, ses besoins, sa
              personnalité
            </p>
          </li>
          <li>
            <p>
              Analyser ses compétences, ses ressources, ses savoirs et ses
              savoir-faire
            </p>
          </li>
          <li>
            <p>
              Repérer sa valeur ajoutée afin de définir un projet professionnel
            </p>
          </li>
          <li>
            <p>Développer son employabilité et sécuriser son parcours</p>
          </li>
          <li>
            <p>Établir une projection positive vers l’avenir</p>
          </li>
          <li>
            <p>Se positionner sur le marché de l'emploi</p>
          </li>
          <li>
            <p>S’orienter et piloter sa carrière de façon autonome</p>
          </li>
          <li>
            <p>Définir ou valider un projet professionnel</p>
          </li>
        </ul>
        <h2>Durée et modalité d’organisation</h2>
        <p>
          24 heures dont 18h00 en face à face et 6h00 de travail individuel
          guidé.
        </p>
        <p>Formation individuelle en présentiel.</p>
        <h2>Lieu</h2>
        <p>
          La formation en présentiel est dispensée à Paris dans les bureaux mis
          à disposition par Natelco, situés 7, Rue Jean Menans – 75019 PARIS
        </p>
        <h2>Accessibilité</h2>
        <p>
          Nos formation et locaux sont accessibles aux personnes en situation de
          handicap. Ces dernières sont invitées à nous informer de leurs besoins
          lors de la validation de votre inscription ou dès que possible. Cela
          nous permettra d’ajuster le parcours de formation.
        </p>
        <p>
          Notre référente Handicap, Mme LEVY Nathalie est disponible au + 33 6
          60 47 85 56 / nathlevys@gmail.com
        </p>
        <h2>Modalités et Délai d’accès</h2>
        <p>
          Une analyse de la demande avec validation de la faisabilité du projet
          sera réalisée ;
        </p>
        <p>
          Un délai de 15 jours est requis entre la prise en charge du bilan de
          compétences par NATELCO et l’entrée dans le bilan.
        </p>
        <h2>Tarifs</h2>
        <p>3 200€ T.T.C / bénéficiaire.</p>
        <p>
          Différents modes de financement possibles. Nous consulter pour toute
          demande.
        </p>
        <p>
          <b>NB</b> : Conditions d’inscription en formation financée via le CPF
          : complétude d’une attestation sur l’honneur qui confirme le droit du
          titulaire à mobiliser ses droits :
          <a href="https://www.of.moncompteformation.gouv.fr/espace-public/sites/of/files/2024-01/attestation-sur-l-honneur-titulaires-de-compte.pdf">
            https://www.of.moncompteformation.gouv.fr/espace-public/sites/of/files/2024-01/attestation-sur-l-honneur-titulaires-de-compte.pdf
          </a>
        </p>
        <p>
          Pour consulter les conditions particulières titulaires :
          <a href="https://of.moncompteformation.gouv.fr/espace-public/sites/of/files/2025-04/CP_Titulaires_V13_VF_sign_0.pdf">
            https://of.moncompteformation.gouv.fr/espace-public/sites/of/files/2025-04/CP_Titulaires_V13_VF_sign_0.pdf
          </a>
        </p>
        <p>
          <b>NB</b> : reste à charge pour tout financement via le CPF (décret
          mai 24) hormis pour les demandeurs d’emploi… nous consulter pour toute
          précision.
        </p>
        <p>
          → En cas de difficultés dans l’activation ou l’utilisation de son
          compte, le Titulaire peut utiliser le guide de connexion disponible
          sur la Plateforme et/ou solliciter l’assistance technique par
          téléphone.
        </p>
        <h2>Déroulé/contenu de la prestation</h2>
        <p>
          Entretien préalable à la réalisation du bilan (gratuit et sans
          engagement)
        </p>
        <ul>
          <li>
            <p>
              Initier un contact avec le consultant qui sera l'interlocuteur
              durant le bilan
            </p>
          </li>
          <li>
            <p>Clarifier les attentes du bénéficiaire</p>
          </li>
          <li>
            <p>
              Informer sur le déroulement total du bilan (informations pratiques
              et légales)
            </p>
          </li>
          <li>
            <p>Établir un devis de prestation</p>
          </li>
        </ul>
        <h3>
          A) Une phase préliminaire de 2h00 (en face à face) qui a pour objectif
          de :
        </h3>
        <ul>
          <li>
            <p>d’analyser votre demande et vos besoins ;</p>
          </li>
          <li>
            <p>
              de déterminer le format le plus adapté à votre situation et à vos
              besoins ;
            </p>
          </li>
        </ul>
        <h3>
          B) Une phase d’investigation de 14h00 (en face à face) permettant au
          bénéficiaire de :
        </h3>
        <ul>
          <li>
            <p>
              d’analyser ses motivations et intérêts professionnels et
              personnels,
            </p>
          </li>

          <li>
            <p>
              d’identifier ses compétences et aptitudes professionnelles et
              personnelles et le cas échéant, d’évaluer ses connaissances
              générales
            </p>
          </li>
        </ul>
        <p>
          <b>
            12 séances de 1h30, soit 18 heures d’ accompagnement via d’échanges interactifs et 6 travaux individuels guidés de 1 heure chacune par le bénéficiaire
          </b>
        </p>
        <ul>
          <li>
            <p>
              Retracer les moments clés du parcours professionnel actuel ainsi
              que les expériences antérieures du bénéficiaire.
            </p>
          </li>

          <li>
            <p>
              Examiner les réalisations passées pour identifier les atouts et
              les axes d’amélioration.
            </p>
          </li>
          <li>
            <p>
              Recenser les compétences développées, qu’elles soient issues du
              domaine professionnel ou d’activités personnelles.
            </p>
          </li>
          <li>
            <p>
              Mettre en lumière les compétences pouvant être mobilisées dans
              d’autres contextes ou métiers.
            </p>
          </li>
          <li>
            <p>
              Clarifier les motivations, les valeurs personnelles et les centres
              d’intérêt liés au travail.
            </p>
          </li>
          <li>
            <p>
              Explorer différentes familles de métiers et secteurs d’activité.
            </p>
          </li>
          <li>
            <p>
              Définir les critères de choix liés au lieu de travail, au type
              d’entreprise et aux fonctions recherchées.
            </p>
          </li>
          <li>
            <p>
              Structurer et prioriser les pistes de projets professionnels
              envisagés.
            </p>
          </li>
          <li>
            <p>
              Réaliser des recherches documentaires et des enquêtes de terrain
              pour valider ces pistes.
            </p>
          </li>
          <li>
            <p>
              Analyser les écarts entre le profil actuel et les exigences de
              chaque projet, notamment à l’aide d’une analyse SWOT.
            </p>
          </li>
          <li>
            <p>
              Arrêter un projet prioritaire et déterminer la stratégie pour le
              concrétiser (formation, financement, échéances…).
            </p>
          </li>
          <li>
            <p>
              Établir un plan d’action détaillé et un calendrier de mise en
              œuvre.
            </p>
          </li>
        </ul>
        <h3>C) Une phase de conclusion de 2h00 (en face à face)</h3>
        <p>
          Qui, par la voie d’un entretien personnalisé, permet au bénéficiaire
          d’intégrer les résultats de la phase d’investigation, identifier les
          ressources favorisant la concrétisation du projet professionnel et en
          planifier les étapes et modalités essentielles.
        </p>
        <p>
          Un bilan est réalisé au bout de 6 mois : 1 heure d'entretien
          individuel qui permettra de faire le point sur votre situation.
        </p>
        <h2>Moyen d’encadrement</h2>
        <p>
          Le consultant accompagne le processus pour aider à initier l’action et
          accompagner le bénéficiaire à la dynamique de changement. Il est
          neutre et bienveillant, à la fois témoin et miroir, dans un processus
          d’écoute active.
        </p>
        <h2>Méthodes mobilisées</h2>
        <ul>
          <li>
            <p>
              Rendez-vous organisés en fonction des disponibilités du
              bénéficiaire
            </p>
          </li>
          <li>
            <p>Échanges avec le bénéficiaire</p>
          </li>
          <li>
            <p>Expérimentations</p>
          </li>
          <li>
            <p>Temps de réflexion individuelle</p>
          </li>
          <li>
            <p>Brainstorming</p>
          </li>
          <li>
            <p>Exercices dirigés</p>
          </li>
          <li>
            <p>
              Support pédagogique recensant l'ensemble des démarches effectuées
            </p>
          </li>
          <li>
            <p>Corédaction d'une synthèse</p>
          </li>
          <li>
            <p>Questionnaires d'évaluation et d'autoévaluation</p>
          </li>
          <li>
            <p>
              Point en début d’entretien, état d’avancement du travail personnel
              demandé, et de la réflexion du bénéficiaire au jour de l’entretien
            </p>
          </li>
          <li>
            <p>Synthèse de l’entretien du jour</p>
          </li>
          <li>
            <p>
              Point en fin d’entretien, recueil des impressions, régulation sur
              les autres journées en fonction de l’évolution pédagogique
            </p>
          </li>
          <li>
            <p>
              Évaluation à chaud en fin de formation, débriefing sur l’écart
              éventuel, formalisation d’une régulation sur les points soulevés.
            </p>
          </li>
        </ul>
        <h2>Moyens pédagogiques</h2>
        <p>
          Un livret d’accompagnement sera remis au bénéficiaire. Il comprendra
          notamment :
        </p>
        <ul>
          <li>
            <p>
              Une sélection de ressources gratuites, incluant les sites
              essentiels pour s’informer sur les métiers, les formations, les
              aides mobilisables et l’accès aux données statistiques.
            </p>
          </li>
          <li>
            <p>
              Des supports permettant de valoriser l’expérience personnelle
              et/ou professionnelle.
            </p>
          </li>
          <li>
            <p>Des outils d’identification des motivations.</p>
          </li>
          <li>
            <p>Des éléments d’enquête terrain.</p>
          </li>
          <li>
            <p>Divers exercices pratiques.</p>
          </li>
        </ul>
        <h2>Modalités d'évaluation des bénéficiaires</h2>
        <ul>
          <li>
            <p>Questions orales (dialectique),</p>
          </li>
          <li>
            <p>Questionnaire écrit</p>
          </li>
          <li>
            <p>
              Mises en situation (enquêtes métiers, enquêtes réseaux sociaux
              professionnels...).
            </p>
          </li>
        </ul>
        <h2>Modalités de suivi et d’évaluation de la prestation</h2>
        <ul>
          <li>
            <p>
              Recueil de vos attentes et besoins afin de co-construire le
              programme de votre bilan.
            </p>
          </li>
          <li>
            <p>
              Co-construction du calendrier de vos séances en fonction de nos
              disponibilités et des vôtres.
            </p>
          </li>
          <li>
            <p>Envoi de convocation</p>
          </li>
          <li>
            <p>
              Feuille de présence signée par vos soins et votre accompagnant à
              la fin de chaque séance.
            </p>
          </li>
          <li>
            <p>Questionnaires d’évaluation d’atteinte des objectifs</p>
          </li>
          <li>
            <p>
              Remise d’une synthèse personnalisée et confidentielle permettant
              l’évaluation de l’atteinte des objectifs.
            </p>
          </li>
          <li>
            <p>Attestation de remise de synthèse.</p>
          </li>
          <li>
            <p>
              Fixation écrite de la date de notre rendez-vous post bilan à 6
              mois.
            </p>
          </li>
          <li>
            <p>
              Questionnaire de satisfaction à chaud à la fin de votre bilan.
            </p>
          </li>
          <li>
            <p>Questionnaire de satisfaction à froid à 6 mois.</p>
          </li>
        </ul>
        <h2>Cadre règlementaire</h2>
        <p>
          Le bilan de compétences est une démarche individuelle, encadrée
          juridiquement par la Loi du 31 Décembre 1991 (R. 6322-35), la Loi n°
          2018-771 du 05 Septembre 2018 « pour la liberté́ de choisir son avenir
          professionnel », et donc les articles L6313-1, L 6313-4 et R 6313-4 à
          R6313- 7 du Code du Travail.
        </p>
        <p>
          Ce cadre définit entre autres les trois phases indispensables à la
          réalisation du bilan et leur contenu nécessaire indiqués dans le
          déroulé/contenu de la formation.
        </p>
        <h2>Nos engagements déontologiques</h2>
        <p>
          L’organisme de formation s’engage à respecter les obligations
          déontologiques fixées par la règlementation définies ci-dessous :
        </p>
        <ul>
          <li>
            <p>Consentement : Respecter le consentement du bénéficiaire</p>
          </li>
          <li>
            <p>
              Ne pas faire de prosélytisme sur le bilan de compétences lors de
              l’entretien d’accueil et de présentation du cabinet.
            </p>
          </li>
          <li>
            <p>
              Respecter le secret professionnel (les personnes chargées de
              réaliser et de détenir les bilans de compétences sont soumises aux
              dispositions de l’art des articles 226-13 et 226-14 du code pénal
              en ce qui concerne les informations qu’elles détiennent)
            </p>
          </li>
          <li>
            <p>
              La nature et la teneur des investigations menées par le
              prestataire : les informations demandées au bénéficiaire doivent
              présenter un lien direct avec l’objet du bilan de compétences. Le
              bénéficiaire est tenu d’y répondre de bonne foi, des lors que les
              questions remplissent les conditions précédemment citées.
            </p>
          </li>
          <li>
            <p>
              Le bilan doit être organisé en 3 phases identifiables
              (Préliminaire, Investigation et Conclusion)
            </p>
          </li>

          <li>
            <p>
              Notion de propriété du bilan : le bénéficiaire est seul
              destinataire des résultats du document de synthèse. Les résultats
              totaux ou partiels sont conditionnés à l’autorisation du
              bénéficiaire et sont définis dans la convention tripartite
            </p>
          </li>
          <li>
            <p>
              L’intégralité des résultats du bilan de compétences doit être
              restituée au bénéficiaire
            </p>
          </li>
          <li>
            <p>
              Le document de synthèse est établi par le prestataire sous sa
              seule responsabilité. Il doit entrer présenté avant sa rédaction
              finale, au bénéficiaire pour d’éventuelles modifications.
            </p>
          </li>
          <li>
            <p>
              Neutralité du consultant : le recours à des méthodes/techniques
              fiables
            </p>
          </li>
          <li>
            <p>
              Confidentialité : Détruire l’intégralité des documents à l’issue
              du Bilan « Les documents élabores pour la réalisation d’un bilan
              de compétences sont aussitôt détruits par l’organisme prestataire,
              toutefois le document de synthèse pourra entre conservé sur
              demande écrite du bénéficiaire fondée sur la nécessité d’un suivi
              de sa situation ; dans cette hypothèse, ils ne pourront être
              gardés plus de trois ans (art R. 6313-7 et L. 6313-4 du code du
              travail).
            </p>
          </li>
        </ul>
        <h2>Hébergement et restauration</h2>
        <p>
          De nombreuses adresses peuvent vous être proposées. Natelco tient une
          liste à disposition de ses stagiaires.
        </p>
      </div>
    )
  }
];

export default bilansData;
